/* eslint-disable import/prefer-default-export */
import { requestPost } from "./ajax"

export const setReportLink = ({ projectId, projectReportLink }) => {
    return requestPost("admin/createReportReady", { projectId, projectReportLink })
}
